import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSupportContact, hasSupportContact } from '../../hooks/useSupportContact';

/**
 * One line naming whom to ask for help — the institution's own contact (Setup
 * › Support Contact), or nothing at all when none is set (parity audit 2,
 * 4.1). `contact` may be passed (the sign-in page has it with the institution
 * card, before anyone is signed in); otherwise it is fetched.
 */
export function SupportContactView({ contact, lead = '', className = '', testId = 'support-contact-line' }) {
  const { t } = useTranslation('exam');
  if (!hasSupportContact(contact)) return null;
  return (
    <p className={className} data-testid={testId}>
      {lead || t('support.needHelp')}{' '}
      {contact.email && <a href={`mailto:${contact.email}`} className="font-semibold underline underline-offset-2">{contact.email}</a>}
      {contact.email && contact.phone && ' · '}
      {contact.phone && <a href={`tel:${String(contact.phone).replace(/[^\d+]/g, '')}`} className="font-semibold underline underline-offset-2">{contact.phone}</a>}
      {contact.hours && <span> ({contact.hours})</span>}
    </p>
  );
}

export default function SupportContactLine(props) {
  const contact = useSupportContact();
  return <SupportContactView contact={contact} {...props} />;
}
